import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import RootCategoriesSection  from "../components/Shop/RootCategoriesSection";
import FeaturedAdvantages   from "../components/Shop/FeaturedAdvantages";
import api from "../api";
import ProductCarousel from "../components/Shop/ProductCarousel";
import FAQSection from "../components/Shop/FAQSection";
import CampaignBannersSection from "../components/Campaign/CampaignBannersSection";
import FeaturedSuppliers from "../components/Shop/FeaturedSuppliers";


const normalizeArray = (data) => {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.results)) return data.results;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};

export default function HomePage() {
  const [rootCategories, setRootCategories] = useState([]);
  const [newestProducts, setNewestProducts] = useState([]);
  const [popularProducts, setPopularProducts] = useState([]);
  const [discountProducts, setDiscountProducts] = useState([]);
  const [loadingCategory, setLoadingCategory] = useState(false);
  const [loadingNewestProducts, setLoadingNewestProducts] = useState(false);
  const [loadingPopularProducts, setLoadingPopularProducts] = useState(false);
  const [loadingDiscountProducts, setLoadingDiscountProducts] = useState(false);
  const [error, setError] = useState(null);

  const fetchRootCategory = async () => {
    setLoadingCategory(true);
    try {
      const response = await api.get("/products/root-categories/");
      setRootCategories(normalizeArray(response.data));
    } catch (e) {
      setError("خطا در دریافت اطلاعات دسته‌ها");
      console.error(e);
      setRootCategories([]);
    } finally {
      setLoadingCategory(false);
    }
  };

  const fetchProducts = async () => {
    setLoadingNewestProducts(true);
    setLoadingPopularProducts(true);
    setLoadingDiscountProducts(true);
    try {
      const response = await api.get("/products/shopping/newest-products/");
      setNewestProducts(normalizeArray(response.data));
      const response_popular = await api.get("/products/shopping/popular-products/");
      setPopularProducts(normalizeArray(response_popular.data));
      const response_discount = await api.get("/products/shopping/highest-discount-products/");
      setDiscountProducts(normalizeArray(response_discount.data));
    } catch (err) {
      setError("خطا در دریافت اطلاعات محصول");
      console.error(err);
      setNewestProducts([]);
      setPopularProducts([]);
      setDiscountProducts([]);
    } finally {
      setLoadingNewestProducts(false);
      setLoadingPopularProducts(false);
      setLoadingDiscountProducts(false);
    }
  };

  useEffect(() => {
    fetchRootCategory();
    fetchProducts();
  }, []);

  return (
    <main className="px-4 py-6 md:px-6 md:py-8 lg:px-8">
      <div className="mx-auto flex max-w-7xl flex-col gap-8">
        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="relative h-[200px]">
            {/* موبایل */}
            <img
                src="/images/homepage-banner-mobile.png"
                alt="بازارگاه کالای ساختمانی"
                className="absolute inset-0 h-full w-full object-cover md:hidden"
            />

            {/* دسکتاپ */}
            <img
                src="/images/homepage-banner.png"
                alt="بازارگاه کالای ساختمانی"
                className="absolute inset-0 hidden h-full w-full object-cover md:block"
            />

            {/* لایه تیره برای خوانایی بهتر متن و دکمه */}
            <div className="absolute inset-0 bg-black/15"/>

            {/* محتوای متنی */}
            <div className="absolute inset-0 flex flex-col items-start justify-center gap-3 px-4 text-white md:px-8">
              <span
                  className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium text-[#FFC107]">
                بازارگاه کالای ساختمانی
              </span>

              <p className="max-w-2xl text-right text-sm leading-7 text-white/80 md:text-base">
                تجربه‌ای ساده، شفاف و قابل اعتماد
              </p>

              <Link
                  to="/root-category-list/"
                  className="mt-1 inline-flex min-h-10 items-center justify-center rounded-lg bg-[#FFC107] px-4 py-2 text-sm font-bold text-gray-900 shadow-sm transition-all duration-200 hover:bg-[#ffca28] hover:shadow-md focus:outline-none focus:ring-2 focus:ring-[#FFC107] focus:ring-offset-2 focus:ring-offset-transparent active:scale-[0.98] md:min-h-11 md:px-5 md:text-base"
              >
                دسته‌بندی‌های اصلی
              </Link>
            </div>
          </div>
        </section>

        <main className="container mx-auto px-4 py-2">
          <FeaturedAdvantages/>
        </main>


        {/* Categories */}
        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-4 sm:px-5">
            <div>
              <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
                دسته‌بندی کالا
              </h2>
              <p className="mt-1 text-xs text-gray-500 sm:text-sm">
                دسته مورد نظر خود را برای شروع انتخاب کنید
              </p>
            </div>
          </div>
          <div className="px-2 py-4 sm:px-2 sm:py-2">
            <RootCategoriesSection
                rootCategories={rootCategories}
                loadingCategory={loadingCategory}
            />
          </div>
        </section>

        <section className="rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between gap-3 border-b border-gray-100 px-4 py-4 sm:px-5">
            <div>
              <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
                جشنواره ها
              </h2>
            </div>
          </div>
          <div className="px-2 py-4 sm:px-2 sm:py-2">
            <CampaignBannersSection/>
          </div>

        </section>

        <section className="overflow-hidden rounded-2xl border border-gray-200 bg-white shadow-sm">
          <div className="flex items-center justify-between border-b border-gray-100 px-3 py-3 sm:px-5 sm:py-4">
            <h2 className="text-sm font-semibold text-gray-800 sm:text-base">
              جشنواره‌ها
            </h2>
          </div>

          <div className="px-3 py-3 sm:px-5 sm:py-5">
            <FeaturedSuppliers/>
          </div>
        </section>


        {/* Newest Products */}
        <section>
          {loadingNewestProducts ? (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                در حال بارگذاری کالاها ...
              </div>
          ) : newestProducts.length > 0 ? (
              <ProductCarousel
                  title="جدیدترین"
                  products={newestProducts}
              />
          ) : (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                کالایی یافت نشد.
              </div>
          )}
        </section>
        <section>
          {loadingPopularProducts ? (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                در حال بارگذاری کالاها ...
              </div>
          ) : popularProducts.length > 0 ? (
              <ProductCarousel
                  title="محبوب ترین"
                  products={popularProducts}
              />
          ) : (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                کالایی یافت نشد.
              </div>
          )}
        </section>
        <section>
          {loadingDiscountProducts ? (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                در حال بارگذاری کالاها ...
              </div>
          ) : discountProducts.length > 0 ? (
              <ProductCarousel
                  title="بیشترین تخفیف"
                  products={discountProducts}
              />
          ) : (
              <div
                  className="rounded-2xl border border-gray-200 bg-white px-4 py-10 text-center text-sm text-gray-500 shadow-sm">
                کالایی یافت نشد.
              </div>
          )}
        </section>

        {/* FAQ */}
        <section>
          <FAQSection/>
        </section>

        {error && (
            <div className="rounded-2xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
              {error}
            </div>
        )}
      </div>
    </main>
  );
}
